module.exports = {
  "name": "ush2022",
  "client": "USH",
  "description": "Mobile app for USH 2022",
  "pluginId": "mobigeo-plugin-ush",
  "validLangs": ["fr"],
  "version": {
    "mainVersion": "4.0.2",
    "buildVersion": {
      "iOS": "77",
      "android": "76",
      "web": "93"
    }
  },
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "11.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 30,
    "androidSigning": {
      "keyAlias": "mobile-spot",
      "keyStorePassword": "jee1Uu0Hieloh7bi"
    },
    "app": "app-react",
    "name": {
      "default": "USH_D"
    },
    "id": "com.mobilespot.ush.dev",
    "appleTeamId": "2BAP3P29V2",
    "playStoreUrl": ""
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {
    "url": "ush2022.ms-dev.mobile-spot.com"
  },
  "relatedRepos": [{
    "src": "git@bitbucket.org:mobilespotdev/cordova.git",
    "branch": "inte/ush2022/main",
    "postCommands": ["cd cordova && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo.git",
    "branch": "inte/ush2022/main",
    "postCommands": ["cd mobigeo && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo-customs-master.git",
    "branch": "inte/ush2022/main",
    "dest": "mobigeo/mobigeo-customs"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/app-react.git",
    "branch": "inte/ush2022/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/data-master.git",
    "branch": "inte/ush2022/main",
    "dest": "app-react/app-customs",
    "postCommands": ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
};